var module = angular.module('octopusApp.projects');
import React from 'react';

TemplateParameters.propTypes =  {
    templateParameters: React.PropTypes.array.isRequired
};

function TemplateParameters(props){
    return <table className="table table-bordered table-striped">
        <thead>
        <tr >
            <td>Name</td>
            <td>Description</td>
        </tr>
        </thead>
        <tbody>
        {props.templateParameters.map(param => {
            return <tr key={param.Name}>
                <td>{!param.Label ? param.Name : param.Label}</td>
                <td dangerouslySetInnerHTML={param.HelpHtml}></td>
            </tr>
        })}
        </tbody>
    </table>;
};

export default TemplateParameters;


// WEBPACK FOOTER //
// ./app/areas/library/steps/views/template_parameters.jsx